import React, {Component, useEffect, useState} from "react";
import {BrowserRouter, Link, Route, Routes} from "react-router-dom";
import TeamDetailPage from "./TeamPlayersPage";
import styles from '../styles/TeamPlayersPage.module.css'
import { useParams } from 'react-router-dom'
import {getColor} from "../helpers/colors";


// function RenderPlayerList(players) {
//     return players.map(player => (
//         <Link className={styles.teamRows} to={`/players/id/${player.id}`} key={player.id}>
//         <li className={styles.listGroupItem}>
//         # Enter Overall Circle Here
//         <div className={styles.playerName}>
//             {player.first_name + ' ' + player.last_name}
//         </div>
//         <span className={styles.mugContainer}>
//             <img className={styles.mug}
//                  src={`https://assets.nhle.com/mugs/nhl/20242025/${player.current_team}/${player.id}.png`}
//                  alt={`${player.first_name + player.last_name}`} />
//         </span>
//     </li>
// </Link>
//     ));
// }
function RenderPlayerList(players, teamColors) {
    return players.map(player => (
        <Link className={styles.teamRows} to={`/players/id/${player.id}`} key={player.id}>
            <li className={styles.listGroupItem}>
                <span className={styles.mugContainer}>
                    <img
                        className={styles.mug}
                        src={`https://assets.nhle.com/mugs/nhl/20242025/${player.current_team}/${player.id}.png`}
                        alt={`${player.first_name} ${player.last_name}`}
                    />
                </span>
                <div className={styles.playerName}>
                    {player.first_name + ' ' + player.last_name}
                </div>
                {/* Overall Circle */}
                <div
                    className={styles.overallCircle}
                    style={{ 
                        borderColor: getColor(player.overall_percentile)
                    }}
                >
                    {Math.round(player.overall_percentile || 0)}
                </div>
            </li>
        </Link>
    ));
}

function PlayersTable(players, team, teamColors) {
    const params = useParams();
    const teamAbb = params.teamAbb
    // console.log(`Look Here, I found it! ${team.location + team.name}`)
    // const teamName = {team.location + team.name}
    return (
        <div className={styles.pageContainer}>
            <div className={styles.glassContainer}>
                <Link className={styles.noDecorationLink} to={`/teams/${team.abb}`} key={team.abb}>
                    <h1 className={styles.teamTableHeading} style={{ color: teamColors?.primary || '#1e293b' }}>
                        <img className={styles.teamLogo}
                                 src={`https://assets.nhle.com/logos/nhl/svg/${teamAbb}_light.svg`}
                                 alt={`${teamAbb} logo`}
                        />
                        {team.location + ' ' + team.name}
                    </h1>
                </Link>
                <div className={styles.playersList}>
                    {RenderPlayerList(players, teamColors)}
                </div>
            </div>
        </div>
    );
}

function TeamPlayersPage() {
    const params = useParams();
    const teamAbb = params.teamAbb
    const [players, setPlayers] = useState([])
    const [team, setTeam] = useState([])
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getData()
            .catch(err => {
                console.log(err);
      });
    }, [])

    const getData = async () => {
        setLoading(true)
        let apiUrl =
        `/api/players/${teamAbb}`
        const playerListResp = await fetch(apiUrl)
        const playerList = await playerListResp.json()
        setPlayers(playerList)

        apiUrl = `/api/teams/${teamAbb}`
        const teamResp = await fetch(apiUrl)
        const teamData = await teamResp.json()
        setTeam(teamData)
        setLoading(false)
    }

    // Function to soften a hex color by mixing with white
    const softenColor = (hexColor, mixRatio = 0.7) => {
        // Remove # if present
        const hex = hexColor.replace('#', '');
        
        // Convert to RGB
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        
        // Mix with white (255, 255, 255)
        const softenedR = Math.round(r * (1 - mixRatio) + 255 * mixRatio);
        const softenedG = Math.round(g * (1 - mixRatio) + 255 * mixRatio);
        const softenedB = Math.round(b * (1 - mixRatio) + 255 * mixRatio);
        
        // Convert back to hex
        return `#${softenedR.toString(16).padStart(2, '0')}${softenedG.toString(16).padStart(2, '0')}${softenedB.toString(16).padStart(2, '0')}`;
    };

    // Compute dynamic background style with softened colors
    const backgroundStyle = team.primary_color && team.secondary_color
      ? {
          background: `linear-gradient(135deg, ${softenColor(team.primary_color)} 0%, ${softenColor(team.secondary_color)} 100%)`
        }
      : {};

    if(loading) return (
        <div className={styles.pageContainer} style={backgroundStyle}>
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    );

    const teamColors = {
        primary: team.primary_color,
        secondary: team.secondary_color
    };

    return (
        <div className={styles.pageContainer} style={backgroundStyle}>
            {PlayersTable(players, team, teamColors)}
        </div>
    )

}

export default TeamPlayersPage


